import Axios from 'axios';
import config from './config';

function getStallStatus() {
  return new Promise((resolve, reject) => {
    try {
      let api_config = {
        url: `${config.URL}/exhibition/status`,
        method: 'get',
      };

      Axios(api_config)
        .then((response) => {
          if (response.data.success) {
            resolve({ success: true, data: response.data.data });
          } else {
            resolve({ success: false });
          }
        })
        .catch((err) => {
          resolve({ success: false });
        });
    } catch (error) {
      resolve({ success: false });
    }
  });
}

function fetchAllBooking() {
  return new Promise((resolve, reject) => {
    try {
      let username = sessionStorage.getItem('username');
      let password = sessionStorage.getItem('password');
      if (!username || !password) {
        return resolve({ success: false, data: 'Not Authorized' });
      }

      let api_config = {
        url: `${config.URL}/exhibition/booking`,
        method: 'get',
        auth: {
          username: atob(username),
          password: atob(password),
        },
      };

      Axios(api_config)
        .then((response) => {
          if (response.data.success) {
            resolve({ success: true, data: response.data.data });
          } else {
            resolve({ success: false, data: response.data.data });
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            sessionStorage.removeItem('username');
            sessionStorage.removeItem('password');
            resolve({ success: false, data: err.message });
          } else {
            resolve({ success: false, data: err.message });
          }
        });
    } catch (error) {
      resolve({ success: false, data: error.message });
    }
  });
}

function createBooking(payload) {
  return new Promise((resolve, reject) => {
    try {
      let api_config = {
        url: `${config.URL}/exhibition/book`,
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        data: payload,
      };

      Axios(api_config)
        .then((response) => {
          if (response.data.success) {
            resolve({ success: true, data: response.data.data });
          } else {
            resolve({ success: false, data: response.data.data });
          }
        })
        .catch((err) => {
          resolve({ success: false, data: err.message });
        });
    } catch (err) {
      resolve({ success: false, data: err.message });
    }
  });
}

function deleteBooking(payload) {
  return new Promise((resolve, reject) => {
    try {
      let username = sessionStorage.getItem('username');
      let password = sessionStorage.getItem('password');
      if (!username || !password) {
        return resolve({ success: false, data: 'Not Authorized' });
      }

      let api_config = {
        url: `${config.URL}/exhibition/booking/${payload.id}`,
        method: 'delete',
        auth: {
          username: atob(username),
          password: atob(password),
        },
      };

      Axios(api_config)
        .then((response) => {
          if (response.data.success) {
            resolve({ success: true, data: response.data.data });
          } else {
            resolve({ success: false, data: response.data.data });
          }
        })
        .catch((err) => {
          resolve({ success: false, data: err.message });
        });
    } catch (err) {
      resolve({ success: false, data: err.message });
    }
  });
}

export default {
  fetchAllBooking,
  getStallStatus,
  createBooking,
  deleteBooking,
};
